/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';
  let comparisonGrid = document.querySelector('.attorney-comparison');

  function sameHeights (container, row) {
    // mboy__todo - create an iterator/counter to go through each block and append row number to make code more dry
    if(comparisonGrid) {
      let number_of_rows = 0;
      let first_column = document.querySelector(container);
      number_of_rows = first_column.querySelectorAll(row).length;

      for(var i = 0;i<number_of_rows;i++) {
        let rows = comparisonGrid.querySelectorAll(container + ' ' + row + ':nth-child(' + (i + 1) + ')');
        let gridCells = [].slice.call(rows);

        let tallest = Math.max.apply(Math, gridCells.map(function(elem, index) {
          elem.style.minHeight = ''; // clean first
          let rect = elem.getBoundingClientRect();
          console.log(rect.height);
          return rect.height;
        }));

        gridCells.forEach((elem, index, arr) => {
          elem.style.minHeight = tallest + 'px';
        });
      }
    }
  }

  var resized = true;
  var timeout = null;

  var refresh = () => {
    if(resized) {
      sameHeights('.compare-practice-areas', '.practice-area');
      sameHeights('.attorney-info', '.block');
    }
    clearTimeout(timeout);
    timeout = setTimeout( refresh, 100);
    resized = false;
  };

  window.addEventListener('resize', () => { resized = true; });

  refresh();


  timeout = setTimeout( () => { resized = true; refresh(); }, 1000);

}());
